import ApexChartsSample from './ApexCharts'
import AverageSample from './Average'
import CustomSample from './Custom'

const ChartSample = (props) => {
  let { chart } = props

  return (
    <>
      {chart?.chartName === 'apexcharts' && <ApexChartsSample {...props} />}
      {chart?.chartName === 'custom' && <CustomSample {...props} />}
      <AverageSample {...props} />
    </>
  )
}

export default ChartSample
